export default "__VITE_ASSET__ec973809__"